// emoticon lists are from https://github.com/Ranks/emojione/blob/master/lib/js/emojione.js
module.exports = {
  '<3':'2764',
  '</3':'1f494',
  ':\')':'1f642',
  ':\'-)':'1f642',
  ':D':'1f603',
  ':-D':'1f603',
  '=D':'1f603',
  ':)':'1f642',
  ':-)':'1f604',
  '=]':'1f604',
  '=)':'1f604',
  ':]':'1f604',
  '\':)':'1f605',
  '\':-)':'1f605',
  '\'=)':'1f605',
  '\':D':'1f605',
  '\':-D':'1f605',
  '\'=D':'1f605',
  '>:)':'1f606',
  '>;)':'1f606',
  '>:-)':'1f606',
  '>=)':'1f606',
  ';)':'1f609',
  ';-)':'1f609',
  '*-)':'1f609',
  '*)':'1f609',
  ';-]':'1f609',
  ';]':'1f609',
  ';D':'1f609',
  ';^)':'1f609',
  '\':(':'1f613',
  '\':-(':'1f613',
  '\'=(':'1f613',
  ':*':'1f618',
  ':-*':'1f618',
  '=*':'1f618',
  ':^*':'1f618',
  '>:P':'1f61c',
  'X-P':'1f61c',
  'x-p':'1f61c',
  '>:[':'1f61e',
  ':-(':'1f61e',
  ':(':'1f61e',
  ':-[':'1f61e',
  ':[':'1f61e',
  '=(':'1f61e',
  '>:(':'1f620',
  '>:-(':'1f620',
  ':@':'1f620',
  ':\'(':'1f622',
  ':\'-(':'1f622',
  ';(':'1f622',
  ';-(':'1f622',
  '>.<':'1f623',
  ':$':'1f633',
  '=$':'1f633',
  '#-)':'1f635',
  '#)':'1f635',
  '%-)':'1f635',
  '%)':'1f635',
  'X)':'1f635',
  'X-)':'1f635',
  '*\\0/*':'1f646',
  '\\0/':'1f646',
  '*\\O/*':'1f646',
  '\\O/':'1f646',
  'O:-)':'1f607',
  '0:-3':'1f607',
  '0:3':'1f607',
  '0:-)':'1f607',
  '0:)':'1f607',
  '0;^)':'1f607',
  'O:)':'1f607',
  'O;-)':'1f607',
  'O=)':'1f607',
  '0;-)':'1f607',
  'O:-3':'1f607',
  'O:3':'1f607',
  'B-)':'1f60e',
  'B)':'1f60e',
  '8)':'1f60e',
  '8-)':'1f60e',
  'B-D':'1f60e',
  '8-D':'1f60e',
  '-_-':'1f611',
  '-__-':'1f611',
  '-___-':'1f611',
  '>:\\':'1f615',
  '>:/':'1f615',
  ':-/':'1f615',
  ':-.':'1f615',
  // ':/':'1f615', comment since it matches with "http://"
  ':\\':'1f615',
  '=/':'1f615',
  '=\\':'1f615',
  ':L':'1f615',
  '=L':'1f615',
  ':P':'1f61b',
  ':-P':'1f61b',
  '=P':'1f61b',
  ':-p':'1f61b',
  ':p':'1f61b',
  '=p':'1f61b',
  ':-Þ':'1f61b',
  ':Þ':'1f61b',
  ':þ':'1f61b',
  ':-þ':'1f61b',
  ':-b':'1f61b',
  ':b':'1f61b',
  'd:':'1f61b',
  ':-O':'1f62e',
  ':O':'1f62e',
  ':-o':'1f62e',
  ':o':'1f62e',
  'O_O':'1f62e',
  '>:O':'1f62e',
  ':-X':'1f636',
  ':X':'1f636',
  ':-#':'1f636',
  ':#':'1f636',
  '=X':'1f636',
  '=x':'1f636',
  ':x':'1f636',
  ':-x':'1f636',
  '=#':'1f636'
};
